import PropTypes from "prop-types";
import React from "react";
import shortid from "shortid";

import patterns from "../constants/patterns";

const keys = patterns.reduce((acc, pattern) => {
  acc[pattern.id] = shortid.generate();
  acc[`${pattern.id}--s`] = shortid.generate();
  acc[`${pattern.id}--t`] = shortid.generate();
  return acc;
}, {});

const key = (seed = "", id, scaled, thumbnail) => {
  let k;

  if (scaled) {
    k = keys[`${id}--s`];
  } else if (thumbnail) {
    k = keys[`${id}--t`];
  } else {
    k = keys[id];
  }
  return `${k}-${seed}`;
};

const Pattern = props => {
  const PatternComponent = props.pattern.component;
  const id = key(
    props.keySeed,
    props.pattern.id,
    props.scaled,
    props.thumbnail,
    props.pngexport,
    props.pdfexportsmallscale
  );

  return (
    <svg width="100%" height="100%" className="pattern-svg">
      <PatternComponent
        id={id}
        scaled={props.scaled}
        configs={props.pattern.configs}
        config={props.config}
        thumbnail={props.thumbnail}
        pngexport={props.pngexport}
        pdfexportsmallscale={props.pdfexportsmallscale}
      />

      <rect
        id="rect"
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill={`url(#${id})`}
      />
    </svg>
  );
};

Pattern.propTypes = {
  scaled: PropTypes.bool,
  config: PropTypes.object,
  pattern: PropTypes.object
};

export default Pattern;



// WEBPACK FOOTER //
// ./src/components/Pattern.js